import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form, Input, notification, Select, } from 'antd'
import { COLOR, FONT } from '../constants';
import useResponsive from '../hooks/useResponsive'
import styled from 'styled-components'
import * as Service from '../core/Service';
import { useWallet } from '@solana/wallet-adapter-react';
import TNContent from './TNContent';
import WhitelistForm from './WhitelistForm';


const ContactButton = styled(Button)`
  width: 100%;
  &:hover, :focus {
    background-color: ${COLOR.content} !important;
    color: #fff !important;
  }

  background-color: ${COLOR.primary} !important;
  border: 3px solid #000000 !important;
  box-shadow: 6px 7px 0px #000000;
  border-radius: 8px;
  height: 100%;
  transition: all 0.5s;
`

const StyledFormContainer = styled.div`
  .ant-form-item-explain-error {
    text-align: start;
    font-family: Space Grotesk !important;
    font-size: 12px;
  }
  .ant-form-item-label {
    padding: 0px;
  }
  .ant-form-item-label span {
    color: #777777;
    font-weight: 500 !important;
  }
  .ant-input:focus, .ant-input-focused {
    box-shadow: none;
  }
  .ant-input[disabled] {
    color: #000;
  }
`

const ContactUs = ({
  setFormSuccess,
  setWhitelistModal
}) => {
  const { isMobile, isTablet } = useResponsive();

  const openNotification = () => {
    notification.success({
      message: 'Submit Success',
      description:
        '',
    });
  };

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);


  const onFinish = async (values) => {
    setLoading(true)
    const resp = await Service.call('post', '/api/whitelist', values);
    setLoading(false)

    if (!resp) {
      return notification.error({ message: 'Network Error', duration: 0 })
    }

    if (resp.status <= 0) {
      return notification.error({ message: resp.errorMessage, duration: 0 })
    }

    form.resetFields();
    // openNotification();
    setWhitelistModal(true);
    setFormSuccess(true);
    window.scrollTo({ behavior: 'smooth', top: document.querySelector('#collection-mint').offsetTop + 120 })
  }

  return (
    <TNContent>
      <Row justify='center'
        style={{ background: COLOR.secondary }}>
        <Col style={{ marginTop: 80, display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}
          xs={22} sm={22} md={11} lg={11}>
          <Row style={{ textAlign: 'start' }}>
            <Col span={24} style={{ marginBottom: 10 }}>
              <img src="./assets/primary_star.svg" alt="" style={isMobile ? { width: 20, marginRight: 8 } : { width: 38, marginRight: 8 }} />

              <span style={
                isMobile ? { ...FONT.h6, color: COLOR.primary } : { ...FONT.h5, color: COLOR.primary }}>
                GET WHITELIST TOKEN
              </span>
            </Col>


            <Col xs={24} sm={24} md={17} lg={13} style={{ marginTop: 15 }}>
              <a href="https://nineblocks.io/contact/" target="_blank" rel="noreferrer">
                <ContactButton style={
                  isMobile || isTablet ? {
                    ...FONT.h6,
                  } : {
                    ...FONT.h5,
                  }
                } >
                  {'>> I need some help ! ....'}
                </ContactButton>
              </a>
            </Col>

            <Col span={24} style={{ marginTop: 30 }}>
              <span style={isMobile || isTablet ? { ...FONT.captionText, color: '#1A1A1A' } : { ...FONT.h6, color: '#1A1A1A' }}>
                {'>>>> Need SOL for gas fee or still in the mist?'}
              </span>
            </Col>

            <Col span={24}>
              <span style={isMobile || isTablet ? { ...FONT.captionText, color: '#1A1A1A' } : { ...FONT.h6, color: '#1A1A1A' }}>
                {'>>>> Leave us your contact - we will get back shortly!'}
              </span>
            </Col>

          </Row>

          <Row>
            <Col xs={0} sm={0} md={24} lg={24}>
              <img src="./assets/contact_us_nft.png" alt="" style={{ width: '80%' }} />
            </Col>
          </Row>
        </Col>


        <Col style={{ textAlign: 'center', marginTop: 80, paddingBottom: isMobile ? 0 : 60 }} xs={22} sm={22} md={10} lg={10}>

          {/* <Row justify='center'>
            <Col xs={24} sm={24} md={14} lg={10}>
              {!wallet?.connected ?
                <ConnectButton
                  style={{ ...FONT.button, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 48, border: 0, borderRadius: 8, marginBottom: 20 }}
                >Connect Wallet</ConnectButton>
                : null}
            </Col>
          </Row> */}
          <WhitelistForm form={form} loading={loading} onFinish={onFinish} />
          <Row>
            <Col xs={24} sm={24} md={0} lg={0}>
              <img src="./assets/contact_us_nft.png" alt="" style={{ width: '100%' }} />
            </Col>
          </Row>

        </Col>
      </Row>
    </TNContent>
  )
}

export default ContactUs;